import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as CheckboxOnIcon } from '../../assets/images/svg/checkbox-on.svg';
import themeColors from '../../assets/styles/themeColors';

const CheckboxOnIconStyled = styled(CheckboxOnIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const CheckboxOn = (props) => <CheckboxOnIconStyled {...props} />;

CheckboxOn.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

CheckboxOn.defaultProps = {
  w: '24px',
  h: '24px',
};

export default CheckboxOn;
